import React from 'react';
import {BrowserRouter as Router, Link, Route, RouteComponentProps, Switch, withRouter} from 'react-router-dom';
import {Family, isFamily, sizeOfFamily} from "./spectra";
import {FamilySelector} from "./FamilySelector";
import {FrontPage} from "./FrontPage";
import {OffsetSelector} from "./OffsetSelector";
import {AxesSelector} from "./AxesSelector";
import {SpectrumWithParams} from "./SpectrumWithParams";
import {useLocalState} from "react-use-persist";
import {ChartContext, HorizontalScale, VerticalScale} from './ChartOptions';

let SelectorWrapper = withRouter(function ({history, match}: RouteComponentProps) {
    const family = (match?.params as any)?.family;
    const offset = (match?.params as any)?.offset;
    if (isFamily(family)) {
        const size = sizeOfFamily(family);
        return (<span>
            <FamilySelector
                onSelect={(f: Family) => {
                    history.push("/" + f)
                }}
                selected={family}
            />
            { (size > 1) ? <OffsetSelector
                familySize={size}
                onSelect={(n: number) => {
                    history.push(`/${family}/${n}`)
                }}
                selected={offset}
            /> : null}
        </span>);
    } else {
        return <FamilySelector onSelect={(f: Family) => {
            history.push("/" + f)
        }} />;
    }
});

function App() {
    const [chartOptions, setChartOptions] = useLocalState("chartOptions", {verticalScale: VerticalScale.dB, horizontalScale: HorizontalScale.harmonics});
    return (<Router>
        <ChartContext.Provider value={chartOptions}>
            <div className="App">
                <header className="App-header">
                    <Link to="/">
                        <img src="/hyrmany-32.png" width="32" height="32" alt="Home" className="home-icon"/>
                        Hyrmany
                    </Link>
                    <Route path="/:family" exact>
                        <SelectorWrapper />
                    </Route>
                    <Route path="/:family/:offset">
                        <SelectorWrapper />
                    </Route>
                    <Route path="/" exact>
                        <SelectorWrapper />
                    </Route>
                    <AxesSelector
                        verticalScale={chartOptions.verticalScale}
                        changeVerticalScale={vs => setChartOptions({horizontalScale: chartOptions.horizontalScale, verticalScale: vs})}
                        horizontalScale={chartOptions.horizontalScale}
                        changeHorizontalScale={hs => setChartOptions({horizontalScale: hs, verticalScale: chartOptions.verticalScale})}
                    />
                </header>
                <Switch>
                    <Route path="/:family/:offset">
                        <SpectrumWithParams />
                    </Route>
                    <Route path="/:family" exact>
                        <SpectrumWithParams />
                    </Route>
                    <Route path="/" exact>
                        <FrontPage />
                    </Route>
                </Switch>
                <footer style={{ fontSize: "10pt" }}>
                    Website &copy; <a href="https://twitter.com/tuftyindigo">Tufty Indigo</a>. Check out some Hydrasynth sounds on <a href="https://soundcloud.com/tuftyindigo">my Soundcloud</a>.
                    Hydrasynth is a trademark of <a href="https://ashunsoundmachines.com/">Ashun Sound Machines</a> (ASM), who also created the wavetables whose spectra are shown here. This site is not affiliated with ASM in any way.
                </footer>
            </div>
        </ChartContext.Provider>
    </Router>);
}

export default App;